export default "<app-pagina-inicial></app-pagina-inicial>\n";